module.exports = __webpack_public_path__ + "c5a8aebf8b3cde104a5d9c81b484ba79.jpg";